"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    if (!element.value) {
        return '';
    }
    const lines = [];
    lines.push('**Test Summary**');
    lines.push('');
    const infoItems = [
        { key: 'percentage', label: 'Passing Percentage' },
        { key: 'attempts', label: 'Attempts' },
        { key: 'testTime', label: 'Time Limit' },
        { key: 'questions', label: 'Questions' },
    ];
    infoItems.forEach(({ key, label }) => {
        const item = element.value[key];
        if ((item === null || item === void 0 ? void 0 : item.show) && (item === null || item === void 0 ? void 0 : item.text)) {
            lines.push(`- **${label}:** ${item.text}`);
        }
    });
    if (lines.length === 2) {
        return '';
    }
    return lines.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
